
    import { Component, Vue, Prop } from 'vue-facing-decorator';
    import Properties from '@/components/main/Properties.vue'

    @Component({
        components: {
            Properties,
        },
    })
    export default class CalculationModelOutput extends Vue {
        @Prop({ default: null }) public model: any;
        @Prop({ default: null }) public subModel: any;
        @Prop({ default: null }) public location: any;
        @Prop({ default: null }) public locationProperties: any;
        @Prop({ default: (() => []) }) private propertyIcons: IconItem[];

        private selectViewLocation(value: any) {
            return value.viewLocation == 1;
        }
    }
